module.exports = __webpack_public_path__ + "media/images/logo_hubba-495dc112c7cdc630c40d9be60dd7eb25.jpg";